import Box from '@mui/material/Box';
import Checkbox, { checkboxClasses } from '@mui/material/Checkbox';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination, {
  tablePaginationClasses,
} from '@mui/material/TablePagination';
import { tableRowClasses } from '@mui/material/TableRow';
import React, { PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';

export const HscanTableCheckbox = styled(Checkbox)`
  &.${checkboxClasses.root}.${checkboxClasses.checked},
    &.${checkboxClasses.root}.${checkboxClasses.indeterminate} {
    color: var(--HScan_dark_blue, #16172c);
  }
`;

export const HscanTablePagination = styled(TablePagination)<{
  component?: string;
}>`
  &.${tablePaginationClasses.root} {
    color: #bdbdbd;
  },
`;

export const HscanTableCheckedCountText = styled.div`
  font-size: 14px;
  color: #666973;
`;

export const HscanTableFooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 14px;
`;

export const HscanTableCell = styled(TableCell)<{
  $isNonTextContent?: boolean;

  $background?: string;
  $border?: string;
  $borderTop?: string;
  $borderRight?: string;
  $borderBottom?: string;
  $borderLeft?: string;
}>`
  &.${tableCellClasses.root} {
    ${p => p.$background && `background: ${p.$background};`}
    /*
    border CSS에 대한 안내문

    border 의 세부 property 로는 border-color, border-width, border-style 이 있고
    각각의 initial value 는 black, 1px, none 이다.
    그래서 border-style 이 정해지게 되면 나온다.
    하지만 border, border-right 등으로 설정하면 위 셋 다 지정해줘야지 안 그러면 기본값이 들어간다.
    border: dashed; 하면 border: 1px dashed black; 들어가는 것과 같다.

    TableCell 은 default value 로 border-bottom-style: solid; 을 가지고 있다

    border-collapsed: collapsed; 인 table 에서 border-top 은 바로 위 셀의 border-bottom 에 가려지게 된다.
    위 셀이 border-bottom: none; 이고 아래 셀이 border-top 을 가져야 보이게 된다.

    collapsed table 의 border 가 그려지는 순서는 <table> border -> <tr> border -> <th>, <td> border 순서로 그려지며
    아래에서 위, 오른쪽에서 왼쪽 순서로 그려진다 (위에 있고 왼쪽에 있는 cell 의 border 가 제일 위에 있다).
    */
    border-color: #e5e7eb;
    border-width: 1px;
    ${p => p.$border}
    ${p => p.$borderTop}
    ${p => p.$borderRight}
    ${p => p.$borderBottom}
    ${p => p.$borderLeft}

    /* 양 끝 cell 의 border 가 table border 를 덮어쓰는 것을 방지 */
    &.${tableCellClasses.root}:first-child {
      border-left: none;
    }
    &.${tableCellClasses.root}:last-child {
      border-right: none;
    }

    font-size: 14px;
    ${p => p.$isNonTextContent && 'line-height: 0;'}
    color: #5a6473;
  }

  &.${tableCellClasses.head} {
    white-space: nowrap;
  }
  &.${tableCellClasses.head}, &.${tableCellClasses.footer} {
    font-size: 12px;
    font-weight: bold;
    background: var(--HScan_default_gray_100, #f3f4f6);
    color: #000000de;
  }

  .${tableRowClasses.selected} &,
  .${tableRowClasses.hover}:hover & {
    color: #16172c;
  }
`;

interface HscanTableProps extends PropsWithChildren {
  head?: ReactNode;
  body?: ReactNode;
  footer?: ReactNode;
}
export const HscanTable = ({
  head,
  body,
  footer,
  children,
}: HscanTableProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        boxSizing: 'border-box',
        border: '1px solid #e5e7eb',
        borderRadius: '4px',
      }}>
      <TableContainer>
        <Table
          sx={{
            minWidth: 'max-content',
          }}>
          {head}
          {body}
          {footer}
        </Table>
      </TableContainer>
      {children}
    </Box>
  );
};
